export const theme = {
  colors: {
    blue: "#3dc8f1",
    green: "#97b997",
    yellow: "#e0d049",
    orange: "#F8851B"
  },
};
